export default __webpack_public_path__ + "static/media/celulares.e70ae9be.jpg";